// extracted by mini-css-extract-plugin
module.exports = {"hover":"styles_hover__22C6H","CardHeader":"styles_CardHeader__1qCKe"};